import { V_FORM_ENUM } from '@/CommonDP/VForm/utils';
const COMPONENT_ENUM = {
  TYPE: 'jy-stage',
  LABEL: '项目阶段'
};
export const STAGE_TYPE = {
  USER: {
    LABEL: "用户在项目中所有阶段",
    VALUE: "user"
  },
  PRJ_ALL: {
    LABEL: "项目所有阶段",
    VALUE: "prjAll"
  }
};
export const schema = {
  group: V_FORM_ENUM.custom,
  type: COMPONENT_ENUM.TYPE,
  icon: 'tree',
  label: COMPONENT_ENUM.LABEL,
  formItemFlag: true,
  component: require('./index.vue').default,
  options: {
    name: '',
    label: COMPONENT_ENUM.LABEL,
    requiredHint: ' ',
    labelHidden: false,
    labelWrap: false, // 自动换行
    labelWidth: '',
    required: false,
    disabled: false,
    position: '',
    labelAlign: '',
    columnWidth: '200px',

    setting: '',

    type: COMPONENT_ENUM.TYPE,
    customClass: '',
    description: '',
    closable: true,
    // displayFieldName: '', // 名称字段
    closeText: '',
    showIcon: false,
    effect: 'light',
    hidden: false,
    multiple2: false, // multiple 被vform下毒,暂用这个

    stageType: STAGE_TYPE.PRJ_ALL.VALUE,
    stageNameKey: '',
    onInitAndUpdate: ''

  },
  props() {
    return {
      setting: () => import('./setting.vue')
    };
  },
  // 事件名 :[事件参数]
  events() {
    return {
      onMounted: [],
      onChange: ['value']
    };
  },
  getSFC: () => {
    return '<div></div>';
  },
  zh: {
    [COMPONENT_ENUM.TYPE]: {
      label: '标签名称'
    }
  }
};
